(function() {
  const STOQ_SELECTORS = [
    '.restock-rocket-button',
    '.stoq-notify-me',
    '.stoq-notify-btn',
    '.stoq-notify-button',
    '[data-stoq-widget]',
    '.restock-rocket-button-container-float-right',
    '.restock-rocket-button-container',
    '.BIS_trigger',
    '.BIS-trigger'
  ];

  const ANCHOR_BUTTON_ID = 'product-add-to-cart';
  const TARGET_CONTAINER_SELECTORS = ['.product-form__buttons', '.productView-action', '.product-form'];

  function log(msg, ...args) {
    // console.log(`[PlantLab Stoq Fix] ${msg}`, ...args);
  }

  function applyStyles(element) {
    element.style.setProperty('position', 'relative', 'important');
    element.style.setProperty('inset', 'auto', 'important');
    element.style.setProperty('top', 'auto', 'important');
    element.style.setProperty('left', 'auto', 'important');
    element.style.setProperty('right', 'auto', 'important');
    element.style.setProperty('bottom', 'auto', 'important');
    element.style.setProperty('float', 'none', 'important');
    element.style.setProperty('transform', 'none', 'important');
    element.style.setProperty('margin', '10px 0 0 0', 'important');
    element.style.setProperty('width', '100%', 'important');
    element.style.setProperty('max-width', '100%', 'important');
    element.style.setProperty('display', 'block', 'important');
    element.style.setProperty('visibility', 'visible', 'important');
    element.style.setProperty('opacity', '1', 'important');
    element.style.setProperty('z-index', '10', 'important');
    element.style.setProperty('height', 'auto', 'important');
    element.style.setProperty('min-height', '44px', 'important');

    const innerBtn = element.querySelector('button') || (element.tagName === 'BUTTON' ? element : null);
    if (innerBtn) {
       innerBtn.classList.add('product-form__submit', 'button', 'button--primary', 'an-horizontal-shaking', 'button-text-change');
       innerBtn.style.setProperty('width', '100%', 'important');
       innerBtn.style.setProperty('background', 'var(--atc-bg-color) !important', 'important');
       innerBtn.style.setProperty('border-radius', 'var(--btn-1-border-radius, 0px)', 'important');
    }
  }

  function hideDuplicateButtons(keepEl) {
    // Procura em todo o documento por botões que pareçam ser do Stoq/BIS
    // e esconde todos, exceto o "keepEl" (o escolhido).
    const allSelectors = [
      '.stoq-notify-me',
      '.stoq-notify-btn',
      '.stoq-notify-button',
      '.stq-notify',
      '.stq-trigger',
      '.BIS_trigger',
      '.BIS-trigger',
      '.restock-alert__button' // O botão duplicado reportado pelo usuário tinha essa classe
    ];

    const candidates = document.querySelectorAll(allSelectors.join(','));
    candidates.forEach((el) => {
      if (el === keepEl || keepEl.contains(el) || el.contains(keepEl)) return;

      // Verifica se o elemento está visível antes de esconder, para evitar re-paint desnecessário
      if (el.style.display !== 'none') {
        el.style.setProperty('display', 'none', 'important');
        log('Escondendo botão duplicado:', el);
      }
    });
  }

  function placeAfterRestockAlert(container, el) {
    const alertEl = container.querySelector('.restock-alert');
    if (!alertEl) {
        // Se não tem alerta de texto, tenta colocar onde estava o botão de add to cart
        const soldOutBtn = document.getElementById(ANCHOR_BUTTON_ID);
        if (soldOutBtn && soldOutBtn.parentNode === container) {
            soldOutBtn.insertAdjacentElement('afterend', el);
            return true;
        }
        container.appendChild(el);
        return true;
    }

    if (alertEl.nextSibling === el) return true;
    alertEl.insertAdjacentElement('afterend', el);
    return true;
  }

  function fixStoqButton() {
    let stoqEl = null;

    // 1. Encontrar o MELHOR candidato a botão Stoq
    // Preferência: Botão que NÃO tem a classe 'restock-alert__button' se possível,
    // pois o usuário disse que esse é o duplicado ruim.
    // Mas se só tiver ele, usamos ele.

    const candidates = [];
    STOQ_SELECTORS.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => candidates.push(el));
    });

    if (candidates.length > 0) {
        // Tenta achar um que NÃO tenha a classe problemática
        stoqEl = candidates.find(el => !el.classList.contains('restock-alert__button'));

        // Se não achou, pega o primeiro que aparecer
        if (!stoqEl) stoqEl = candidates[0];
    }

    if (!stoqEl) {
      const soldOutBtn = document.getElementById(ANCHOR_BUTTON_ID);
      if (soldOutBtn && soldOutBtn.style.display === 'none') {
         soldOutBtn.style.display = '';
      }
      return;
    }

    // 2. Encontrar Container Destino
    let targetContainer = null;
    for (const sel of TARGET_CONTAINER_SELECTORS) {
      targetContainer = document.querySelector(sel);
      if (targetContainer) break;
    }

    if (!targetContainer) return;

    // 3. Mover
    if (stoqEl.parentElement !== targetContainer) {
      targetContainer.appendChild(stoqEl);
    }

    // 4. Posicionar e Estilizar
    placeAfterRestockAlert(targetContainer, stoqEl);
    applyStyles(stoqEl);

    // 5. Limpar duplicatas
    hideDuplicateButtons(stoqEl);

    // 6. Esconder botão original
    const soldOutBtn = document.getElementById(ANCHOR_BUTTON_ID);
    if (soldOutBtn) {
      if (soldOutBtn.style.display !== 'none') {
          soldOutBtn.style.display = 'none';
      }
    }
  }

  setInterval(fixStoqButton, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixStoqButton);
  } else {
    fixStoqButton();
  }

})();
